<template>
  <div :class="'general-warning ' + status">
    <alert-icon title="" style="font-size: 0.8em;margin-bottom:2px;"></alert-icon>
    <p>{{warning}}</p>
  </div>
</template>

<script>
export default {
  name: 'fw-monit',
  data () {
    return {
      warningText: ''
    }
  },
  props: {
    warning: [String]
  },
  computed: {
    status() {
      return !!this.warning ? 'is-visible' : 'not-visible';
    },
  }
}
</script>


<style scoped>
  .general-warning {
   
    position: fixed;
    bottom: 0px;
    text-transform: uppercase;
    display: flex;
    justify-content: center;
    align-items: flex-start;  
    font-size: 0.85em;
  }
  .general-warning p{
    margin-left: 4px;
  }
  .is-visible {
  }
  .not-visible {
    display: none;
  }
  @media screen and (max-width: 767px) {
    .general-warning {
      bottom: 45px;
      height: 19px;
    }
  }
</style>